<div class="col-md-12 mb-30" [hidden]="ExpertCalibrationEdit.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات  پرسنلی</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">نام و نام خانوادگی</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button  type="button" (click)="ReadData_Persone()" class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام و نام خانوادگی</th>
              <th>کدملی</th>
              <th>تاریخ استخدام در بهینه</th>
              <th>علامت اختصاری در بهینه فرآیند آزما</th>
              <th>کارشناس کالیبراسیون</th>
              <th>وضعیت</th>
              <th>تاریخ</th>
              <th>کاربر</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
             <td>{{DataList_Persone.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.codemeli}}</td>
              <td>{{item.tarikh_Eshtekhdam}}</td>
              <td>{{item.almat_Ekhtesari}}</td>
              <td>
                <p *ngIf="item.expert_Calibration==0" style="color: crimson;">ثبت نشده است</p>
                <p *ngIf="item.expert_Calibration==1" style="color: #489b39;">داخل آزمایشگاه</p>
                <p *ngIf="item.expert_Calibration==2" style="color: #489b39;">خارج آزمایشگاه</p>
                <p *ngIf="item.expert_Calibration==3" style="color: #489b39;">داخل/خارج آزمایشگاه</p>
              </td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">فعال</p>
                <p *ngIf="item.del" style="color: crimson;">غیر فعال</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        امکانات
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">

                        <a class="dropdown-item" [routerLink]="['/PersonEdit1',{id:item.id}]"><i class="fa fa-edit"></i> ویرایش سوابق پرسنلی </a>

                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>





